<template>

    <div class="page p-patient">
        <the-dashboard-heading :back-href="{ name: 'Patients' }">
            <h2>
                <router-link :to="{ name: 'Patients' }">Pacjenci</router-link>
                <span>{{ patientName }}</span>
            </h2>
            <v-btn
                type="white"
                :to="{ name: 'PatientEventAdd', params: {id: patient.id} }">
                Zaplanuj wizytę
            </v-btn>
        </the-dashboard-heading>
        <the-dashboard-content>

            <div class="p-patient__col p-patient__col--left">
                <patient-issues></patient-issues>
                <patient-events></patient-events>
            </div>
            <div class="p-patient__col p-patient__col--right">
                <patient-info></patient-info>
            </div>
        </the-dashboard-content>

    </div>

</template>


<script>

import {mapGetters} from 'vuex'
import store from 'Store'

import TheDashboardHeading from 'Components/Dashboard/TheDashboardHeading'
import TheDashboardContent from 'Components/Dashboard/TheDashboardContent'

import PatientEvents from 'Components/Patient/PatientEvents'
import PatientIssues from 'Components/Patient/PatientIssues'
import PatientInfo from 'Components/Patient/PatientInfo'

import VLoader from 'Components/VLoader'
import VBtn from 'Components/VBtn'

export default {

    name: 'ViewPatientShow',

    data() {
        return {
            isFetching: false
        }
    },

    computed: {
        ...mapGetters('patient', ['patient']),

        patientName() {
            return this.patient.first_name + ' ' + this.patient.last_name
        },
    },

    beforeRouteEnter(to, from, next) {
        store.dispatch('PAGE_LOADING_SET')
        Promise.all([
            store.dispatch('patient/FETCH_PATIENT', to.params.id),
            store.dispatch('patient/FETCH_ISSUES', {
                id: to.params.id,
                page: to.query.issues_page
            }),
            store.dispatch('patient/FETCH_EVENTS', {
                id: to.params.id,
                page: to.query.events_page
            }),
        ]).then(() => {
            store.dispatch('PAGE_LOADING_RESET')
            next()
        })
    },

    components: {
        TheDashboardHeading,
        TheDashboardContent,
        PatientIssues,
        PatientEvents,
        PatientInfo,
        VLoader,
        VBtn
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.p-patient {
    &__col {
        display: flex;
        align-items: stretch;
        flex-wrap: wrap;

        &--left {
            width: calc(100% - 450px);
        }
        &--right {
            width: 450px;
        }
        section {
            width: 100%;
        }
        @include bp($screen-xl) {
            width: 100%;
        }
    }
}

</style>
